import React, { FC } from 'react';
import TRP from '../shared/TRP';
import './MSCIStatement.scss';

type Props = {};

const MSCIStatement: FC<Props> = () => (
  <div className="disclaimer">
    <TRP /> uses the current MSCI/S&P Global Industry Classification Standard
    (GICS) for sector and industry reporting. <TRP /> will adhere to all updates
    to GICS for prospective reporting.
  </div>
);

export default MSCIStatement;
